/** Static deck served from `public/` (CRA → root URL). */
export const DECK_HTML_PATH = '/deck.html';

export function openDeckPage() {
  window.open(DECK_HTML_PATH, '_blank', 'noopener,noreferrer');
}
